<template>
	<div>
		<div class="" style="position: relative;width:100%;height: 100%;">
			<div id="jrfw" style="width:100%;height:100%;"></div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				data: [],
				myChart: ''
			}
		},
		mounted() {
			this.$request('/center/home/rightOne').then(res => {
				this.init(res.data.list);
			})
		},
		methods: {
			init(pageData) {
				let that = this
				this.myChart = echarts.init(document.getElementById("jrfw"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});
				let bgColor = '#fff';
				let title = '总量';
				let color = ['#2A8BFD', '#BAFF7F', '#00FAC1', '#00CAFF', '#FDE056', '#4ED33C', '#FF8A26', '#FF5252',
					'#9689FF', '#CB00FF'
				]
				let echartData = [{
						name: "股权融资",
						value: "4.6"
					},
					{
						name: "债权融资",
						value: "1.5"
					},
					{
						name: "政府补贴",
						value: "0.6"
					},
					{
						name: "创新工具",
						value: "0.2"
					}
					
				];

				let formatNumber = function(num) {
					let reg = /(?=(\B)(\d{3})+$)/g;
					return num.toString().replace(reg, ',');
				}
				let total = echartData.reduce((a, b) => {
					return a + b.value * 1
				}, 0);

				var option = {
					// backgroundColor: "#061740",
					color: color,
					tooltip: {
						trigger: 'item',
						formatter: params => {
							console.log(params);
							return (
								`${params.data.name}&nbsp;&nbsp;&nbsp;&nbsp;${params.data.value}亿元`
							);
						},
					},
					legend: {
					    bottom: '5%',
					    icon: 'rect',
					    itemWith: 10,
					    itemHeight: 10,
						width:'100%',
					    textStyle: {
							 color: '#fff',
							 fontSize:10
					    },
					  },
					// title: [{
					// 	text: '{name|' + title + '}\n{val|' + formatNumber(total) + '}',
					// 	top: 'center',
					// 	left: 'center',
					// 	textStyle: {
					// 		rich: {
					// 			name: {
					// 				fontSize: 14,
					// 				fontWeight: 'normal',
					// 				color: '#fff',
					// 				padding: [10, 0]
					// 			},
					// 			val: {
					// 				fontSize: 32,
					// 				fontWeight: 'bolder',
					// 				color: '#fff',
					// 			}
					// 		}
					// 	}
					// }, ],
					series: [{
						type: 'pie',
						roseType: 'radius',
						radius: ['30%', '70%'],
						center: ['50%', '35%'],
						data: echartData,
						hoverAnimation: false,
						labelLine: {
							show: false,
							// normal: {
							// 	length: 0,
							// 	length2: 0,
							// }
						},
						label: {
							show: false,
							normal: {
								formatter: params => {
									return (
										'{icon|●}{name|' + params.name + '}\n{value|' +
										formatNumber(params.value) + '}'
									);
								},

								rich: {
									icon: {
										fontSize: 0,
										color: 'inherit'
									},
									name: {
										fontSize: 0,
										padding: [0, 0, 0, 10],
										color: '#fff'
									},
									value: {
										fontSize: 0,
										fontWeight: 'bolder',
										padding: [10, 0, 0, 20],
										color: 'inherit'

									}
								}
							}
						},
					}]
				};


				this.myChart.setOption(option);

				setInterval(function() {
					that.myChart.clear()
					that.myChart.setOption(option);
				}, 15000)
			}
		}
	}
</script>

<style scoped>
	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg {
		width: 30rpx;
		height: 30rpx;

	}
</style>